import React, { useState } from "react";
import layoutStyles from "../PanelUser/PanelLayout.module.css";
import styles from "./MisCitas.module.css";
import axiosInstance from "../../api/axiosConfig";
import {
  PanelSidebar,
  PanelHeader,
  useUserData,
  getTipoBadge,
  getEstadoBadge,
  formatDate,
  MOCK_USER,
} from "../PanelUser/PanelShared";

const MOCK_CITAS = {
  proximas: [
    {
      id: 1,
      specialty: "Medicina General",
      professional_name: "Ana",
      professional_last_name: "Torres",
      date: "2026-03-18",
      time: "10:00 am",
      type: "Teleconsulta",
      status: "Confirmada",
    },
    {
      id: 2,
      specialty: "Pediatría",
      professional_name: "Luis",
      professional_last_name: "Mendoza",
      date: "2026-03-22",
      time: "3:30 pm",
      type: "Domicilio",
      status: "Pendiente",
    },
  ],
  historial: [
    {
      id: 10,
      specialty: "Cardiología",
      professional_name: "Roberto",
      professional_last_name: "Vega",
      date: "2026-02-28",
      time: "9:00 am",
      type: "Teleconsulta",
      status: "Completada",
    },
    {
      id: 11,
      specialty: "Dermatología",
      professional_name: "Patricia",
      professional_last_name: "Lima",
      date: "2026-02-16",
      time: "11:00 am",
      type: "Domicilio",
      status: "Completada",
    },
    {
      id: 12,
      specialty: "Medicina General",
      professional_name: "Marco",
      professional_last_name: "Castro",
      date: "2026-01-30",
      time: "10:00 am",
      type: "Teleconsulta",
      status: "Cancelada",
    },
    {
      id: 13,
      specialty: "Fisioterapia",
      professional_name: "Carmen",
      professional_last_name: "López",
      date: "2026-01-15",
      time: "4:00 pm",
      type: "Presencial",
      status: "Completada",
    },
    {
      id: 14,
      specialty: "Dermatología",
      professional_name: "Patricia",
      professional_last_name: "Lima",
      date: "2025-12-10",
      time: "11:00 am",
      type: "Teleconsulta",
      status: "Completada",
    },
  ],
};

const TABS = ["Próximas", "Historial", "Confirmadas", "Canceladas"];

function getInitials(a = "", b = "") {
  return `${a[0] || ""}${b[0] || ""}`.toUpperCase() || "?";
}

export default function MisCitas() {
  const user = useUserData(axiosInstance) || MOCK_USER;
  const [tab, setTab] = useState("Próximas");
  const [selected, setSelected] = useState(null);

  const allCitas = [...MOCK_CITAS.proximas, ...MOCK_CITAS.historial];

  const filteredCitas = (() => {
    if (tab === "Próximas") return MOCK_CITAS.proximas;
    if (tab === "Historial") return MOCK_CITAS.historial;
    if (tab === "Confirmadas")
      return allCitas.filter((c) => c.status.toLowerCase() === "confirmada");
    if (tab === "Canceladas")
      return allCitas.filter(
        (c) => c.status.toLowerCase() === "cancelada" || c.status.toLowerCase() === "cancelled",
      );
    return allCitas;
  })();

  return (
    <div className={layoutStyles.panelPage}>
      <PanelSidebar user={user} />

      <main className={layoutStyles.main}>
        <PanelHeader label="Mi panel" title="Mis citas" user={user} />

        <p className={styles.subtitle}>Gestioná tus turnos y consultá el historial de citas.</p>

        {/* Filtros + botón */}
        <div className={styles.toolbar}>
          <div className={styles.tabs}>
            {TABS.map((t) => (
              <button
                key={t}
                className={`${styles.tab} ${tab === t ? styles.tabActive : ""}`}
                onClick={() => setTab(t)}
              >
                {t}
              </button>
            ))}
          </div>
          <a href="/" className={styles.btnNueva}>
            + Nueva cita
          </a>
        </div>

        <div className={styles.twoCol}>
          {/* Lista */}
          <div className={layoutStyles.card}>
            <p className={styles.listCount}>Total: {filteredCitas.length} cita(s)</p>
            {filteredCitas.length === 0 ? (
              <p className={layoutStyles.emptyState}>No hay citas en esta categoría.</p>
            ) : (
              filteredCitas.map((c) => (
                <div
                  key={c.id}
                  className={`${styles.citaRow} ${selected?.id === c.id ? styles.citaRowActive : ""}`}
                  onClick={() => setSelected(c)}
                >
                  <div className={styles.citaAvatar}>
                    {getInitials(c.professional_name, c.professional_last_name)}
                  </div>
                  <div className={styles.citaInfo}>
                    <p className={styles.citaSpec}>{c.specialty}</p>
                    <p className={styles.citaDoc}>
                      Dr/a. {c.professional_name} {c.professional_last_name}
                    </p>
                    <p className={styles.citaDate}>
                      {formatDate(c.date)} · {c.time}
                    </p>
                  </div>
                  <div className={styles.citaMeta}>
                    {getTipoBadge(c.type)}
                    {getEstadoBadge(c.status)}
                  </div>
                </div>
              ))
            )}
            {tab === "Próximas" && (
              <p className={styles.notice}>
                Podés cancelar una cita hasta 2 horas antes de la cita para no penalizarte sin cargo
                adicional.
              </p>
            )}
          </div>

          {/* Detalle */}
          <div className={layoutStyles.card}>
            {!selected ? (
              <p className={layoutStyles.emptyState}>Seleccioná una cita para ver el detalle.</p>
            ) : (
              <div className={styles.detail}>
                <div className={styles.detailHeader}>
                  <div className={styles.detailAvatar}>
                    {getInitials(selected.professional_name, selected.professional_last_name)}
                  </div>
                  <div>
                    <p className={styles.detailSpec}>{selected.specialty}</p>
                    <p className={styles.detailDoc}>
                      Dr/a. {selected.professional_name} {selected.professional_last_name}
                    </p>
                  </div>
                </div>
                <div className={styles.detailRow}>
                  <span>Fecha</span>
                  <strong>{formatDate(selected.date)}</strong>
                </div>
                <div className={styles.detailRow}>
                  <span>Hora</span>
                  <strong>{selected.time}</strong>
                </div>
                <div className={styles.detailRow}>
                  <span>Tipo</span>
                  {getTipoBadge(selected.type)}
                </div>
                <div className={styles.detailRow}>
                  <span>Estado</span>
                  {getEstadoBadge(selected.status)}
                </div>
                {(selected.status === "Confirmada" || selected.status === "Pendiente") && (
                  <button className={styles.btnCancelar}>Cancelar cita</button>
                )}
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
